import { render } from "./main_index.vue?vue&type=template&id=86cb16ae&scoped=true"
import script from "./main_index.vue?vue&type=script&lang=js"
export * from "./main_index.vue?vue&type=script&lang=js"

import "./main_index.vue?vue&type=style&index=0&id=86cb16ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86cb16ae"]])

export default __exports__